import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { buildHomeJsonLd } from '@/lib/seo';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ContentSections from './components/ContentSections';
import PillarArticles from './components/PillarArticles';
import Faq from './components/Faq';
import FinalCta from './components/FinalCta';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={buildHomeJsonLd()} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ContentSections />
        <PillarArticles />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}